import {useDispatch} from "react-redux";
import * as rest from "../../../services";
import {showErrorToast, showSuccessToast} from "../../../state/toasts";
import * as components from "../../../components";
import * as ReactBootstrap from "react-bootstrap";
import React from "react";

export const GSXInformationDeleteButton = ({

  information,
  onDelete
}) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
    new rest.GSXInfoService(information.url)
      .makeDeleteRequest()
      .then((response) => {
        onDelete(response)
        dispatch(
          showSuccessToast(
            'Success',
            `Ticket GSX Information has been deleted.`
          )
        )
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body="Are you sure you want to delete this GSX information?"
        confirmText="Confirm Delete"
        confirmBSStyle="danger"
        title="Delete GSX information"
      >
        <ReactBootstrap.Button size="sm" variant="danger" eventKey="1">
          {components.ICONS.DELETE} Delete
        </ReactBootstrap.Button>
      </components.Confirm>
    </>
  )
}
